import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const fetchScenarios = createAsyncThunk('scenarios/fetchAll', async () => {
  const res = await api.get('/scenarios');
  return res.data;
});

export const fetchScenario = createAsyncThunk('scenarios/fetchOne', async (id) => {
  const res = await api.get(`/scenarios/${id}`);
  return res.data;
});

export const createScenario = createAsyncThunk('scenarios/create', async (data) => {
  const res = await api.post('/scenarios', data);
  return res.data;
});

export const updateScenario = createAsyncThunk('scenarios/update', async ({ id, data }) => {
  const res = await api.put(`/scenarios/${id}`, data);
  return res.data;
});

export const deleteScenario = createAsyncThunk('scenarios/delete', async (id) => {
  await api.delete(`/scenarios/${id}`);
  return id;
});

const scenarioSlice = createSlice({
  name: 'scenarios',
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrent(state) {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScenarios.pending, (state) => { state.loading = true; })
      .addCase(fetchScenarios.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchScenarios.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchScenario.fulfilled, (state, action) => {
        state.current = action.payload;
      })
      .addCase(createScenario.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })
      .addCase(updateScenario.fulfilled, (state, action) => {
        state.current = action.payload;
        const idx = state.list.findIndex((s) => s._id === action.payload._id);
        if (idx >= 0) state.list[idx] = action.payload;
      })
      .addCase(deleteScenario.fulfilled, (state, action) => {
        state.list = state.list.filter((s) => s._id !== action.payload);
      });
  },
});

export const { clearCurrent } = scenarioSlice.actions;
export default scenarioSlice.reducer;
